import { EdgeClient } from 'common/generated/edgeClient'
import { EnhancedInputConfig } from 'common/api/v1/internal'

export class GraphApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  readGraph(): Promise<EnhancedInputConfig> {
    return this.edgeClient.getServiceGraphConfig()
  }
}
